import { SellYourCarPage } from '@ltvco/refresh-lib/v2';

const ASSET_BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, '');

const TOOLS_IMAGE_SRC = {
  mobile: `${ASSET_BASE_URL}/assets/images/market-value-mobile.svg`,
  tablet: `${ASSET_BASE_URL}/assets/images/market-value-tablet.svg`,
  desktop: `${ASSET_BASE_URL}/assets/images/market-value-desktop.svg`,
};

export function MarketplaceSellYourCar() {
  return <SellYourCarPage brandName="Bumper" toolsImageSrc={TOOLS_IMAGE_SRC} />;
}
